import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PromoCountdown from "@/components/PromoCountdown";
import EditorialMarquee from "@/components/Marquee";
import Institutional from "@/components/Institutional";
import Experiences from "@/components/Experiences";
import Timeline from "@/components/Timeline";
import Portfolio from "@/components/Portfolio";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App bg-white text-[#0A0A0A]">
            <div className="grain-overlay" />
            <Header />
            <main>
                <Hero />
                <PromoCountdown />
                <EditorialMarquee />
                <Institutional />
                <Experiences />
                <Testimonials />
                <Timeline />
                <Portfolio />
                <Manifesto />
                <FinalCTA />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}

export default App;
